import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
// import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/Menu';
import PrivateRoutes from './components/PrivateRoutes'
import { firebaseApp, signOut } from './firebase'
import Index from './components/index'
import PrivacyPolicy from './components/PrivacyPolicy'
import Tutorial from './components/Tutorial'
import TermsAndConditions from './components/TermsAndConditions'
import Divider from '@material-ui/core/Divider';
import MoreVert from '@material-ui/icons/MoreVert'
import Business from './components/Business'
import Partners from './components/Partners'
import Public from './components/Public'
import DownloadURL from './components/DownloadURL'
import LegalDocs from './components/LegalDocs'

import MainScreen from './screens/main.screen';

import stores from './stores';
import { inject,observer } from 'mobx-react';

export default class App extends Component {

  constructor(props){
    super(props)
    this.state = {
      left: false,
      isAuthenticated: false,
      authUser: null,
      admin: false,
      vendor: false,
      loader: true,
      user: null,
      download: false,
      fromApp: false
    }

    this.toggleDrawer = this.toggleDrawer.bind(this)
    this.login = this.login.bind(this)
    this.logout = this.logout.bind(this)
    this.togglePage = this.togglePage.bind(this)
    this.fromApp = this.fromApp.bind(this)
  }

  componentDidMount() {

  }

  toggleDrawer(){
    this.setState({left: !this.state.left})
  }

  togglePage(page) {
    switch(page){
      case "/download":
        this.setState({download: true})
      break;
    }
  }

  login() {
    this.setState({isAuthenticated: true})
  }

  logout (){
    this.setState({admin: false,vendor: false, authUser: null, isAuthenticated: false}, signOut)
  }

  fromApp() {
    let path = window.location.pathname;
    console.log('path',path);

    if(path === '/download' || path === '/tutorial' || path === '/privacy' || path === '/about') {
      this.setState({fromApp: true})
    }
  }

  render() {

    return (
      <MainScreen />
    )
  }
}

const styles = {
  container:{
    //flex: 1,
    //justifyContent: 'center'
  },
  bar: {
    flex: 1,
    flexDirection: 'row'
  },
  drawer:{
    width: 300,
    paddingTop: 50

  },
  menuItem: {
    fontSize: 20,
    color: '#3748ac'
  },
  paper: {
    // marginTop: theme.spacing.unit * 15,
    display: 'inline-block',
    paddingBottom: 50,
    width: '100%'
  },
  image:{
    height: 50,
    width: 50,
    margin: 10,
    marginRight: 15,
    borderRadius: 50
  }
}



// WEBPACK FOOTER //
// ./src/App.js